// extracted by mini-css-extract-plugin
module.exports = {"blog-hero":"blog-hero_blog-hero__w8EXa","blog-hero__img":"blog-hero_blog-hero__img__c0_wo","blog-hero__description":"blog-hero_blog-hero__description__Axfhk"};